// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"TabContentItem__tabItem"};